function n(r) {
  var e = -1, a = Array(r.size);
  return r.forEach(function(t) {
    a[++e] = t;
  }), a;
}
var o = n;
export {
  o as default
};
//# sourceMappingURL=_setToArray.js.map
